// function logEvent() {
//   window.optimizely = window.optimizely || [];
// 	window.optimizely.push({
// 		type: 'event',
// 		eventName: 'summary-calculator',
// 		tags: {
// 			ab_test: 'summary-calculator',
// 			ab_test_variant: 'summary-calculator_enabled'
// 		}
// 	});

// 	if (window.logEvergageExperienceAmplitudeEvent) {
// 		window.logEvergageExperienceAmplitudeEvent({
// 			ab_test: 'summary-calculator',
// 			ab_test_variant: 'summary-calculator_enabled'
// 		});
// 	}
// }

// function initVariation() {
//   sessionStorage.setItem('isSummaryCalculatorEnabled', 'true');
//   let calculator = document.querySelector('.summary-calculator') 
//   if(calculator){
// 	calculator.classList.remove('d-none')
// 	calculator.classList.add('d-block')

//   }
  
// }

// try {
//   setTimeout(function() {
// 	  initVariation();
//   	logEvent();
//   }, 200);
// } catch (err) {
// 	console.error('[OPTIMIZELY] error', err);
// }


const summaryCalculator = document.querySelectorAll('.summary-calculator')

if(summaryCalculator?.length > 0) {
	Array.from(summaryCalculator).forEach(calcEl => {
		const sendAmountEl = calcEl.querySelector('.sender-amount')
		const amountEl = calcEl.querySelector('.amount-container .value')
		const reciverCurrencySelectDropdown = calcEl.querySelector('.reciver-currency-select-dropdown')
		amountEl.innerText = `${sendAmountEl.value} ${reciverCurrencySelectDropdown.getAttribute('data-currency')}`
		if(sendAmountEl && amountEl && reciverCurrencySelectDropdown) {
			sendAmountEl.addEventListener('input', (e) => {
				let sendAmountLimit = sessionStorage.getItem('sendAmountLimit')
				sendAmountLimit = sendAmountLimit ? parseFloat(sendAmountLimit) : null;
				const enteredAmount = parseFloat(e.target.value || 0)
				if(enteredAmount < 0 || (sendAmountLimit && enteredAmount > sendAmountLimit)){
					amountEl.innerText = `0 ${reciverCurrencySelectDropdown.getAttribute('data-currency')}`;					
					return;
				}
				amountEl.innerText = `${e.target.value} ${reciverCurrencySelectDropdown.getAttribute('data-currency')}`
			})
		}
	})
}
